
import React from 'react';
import { Provider } from 'react-redux';
import { create } from 'dva-core';
import { history } from '@@/core/history';
import { dva as appDva } from '@/app';
import model_0 from '/app/src/models/commModels.js';
import model_1 from '/app/src/pages/adjust/adjust_detail/models/adjusDetail.js';
import model_2 from '/app/src/pages/adjust/adjust_list/models/adjustList.js';
import model_3 from '/app/src/pages/adjust/adjust_view/adjust_view_detail/models/crowdAdd.js';
import model_4 from '/app/src/pages/adjust/adjust_view/models/adjustmentData.js';
import model_5 from '/app/src/pages/adjust/card_merge/models/cardConsolidation.js';
import model_6 from '/app/src/pages/adjust/patch_coupon/models/crowdAdd.js';
import model_7 from '/app/src/pages/bre/_comm/models/bre.js';
import model_8 from '/app/src/pages/bre/dgm/der/models/index.js';
import model_9 from '/app/src/pages/bre/dgm/dgm/dgmp/dgcl/models/dgcl.js';
import model_10 from '/app/src/pages/bre/dgm/dgm/dgmp/dgic/models/dgmp.js';
import model_11 from '/app/src/pages/bre/dgm/dgm/dgmp/models/dgmp.js';
import model_12 from '/app/src/pages/bre/dgm/dgm/models/memberManagement.js';
import model_13 from '/app/src/pages/bre/dgm/dgt/test/models/dgtTest.js';
import model_14 from '/app/src/pages/bre/dgm/dr/models/index.js';
import model_15 from '/app/src/pages/bre/dgm/dvm/models/index.js';
import model_16 from '/app/src/pages/bre/fm/cfpm_detail/models/index.js';
import model_17 from '/app/src/pages/bre/fm/cfpm/models/index.js';
import model_18 from '/app/src/pages/bre/fm/tvf/cfg/c_handle_detail/models/tvfConditionDetail.js';
import model_19 from '/app/src/pages/bre/fm/tvf/cfg/c_unit_test/models/tvfUnitTest.js';
import model_20 from '/app/src/pages/bre/fm/tvf/cfg/models/tvfCondition.js';
import model_21 from '/app/src/pages/bre/fm/tvf/models/index.js';
import model_22 from '/app/src/pages/bre/mm/md/cfg/models/mdCondition.js';
import model_23 from '/app/src/pages/bre/mm/md/models/modaldetail.js';
import model_24 from '/app/src/pages/bre/mm/models/memberManagement.js';
import model_25 from '/app/src/pages/bre/mm/ol/models/ol.js';
import model_26 from '/app/src/pages/bre/rm/models/ruleManage.js';
import model_27 from '/app/src/pages/bre/rm/rule/cfg/c_handle_detail/models/conditionDetail.js';
import model_28 from '/app/src/pages/bre/rm/rule/cfg/c_unit_test/models/UnitTest.js';
import model_29 from '/app/src/pages/bre/rm/rule/cfg/models/condition.js';
import model_30 from '/app/src/pages/bre/rm/rule/models/ruleManageDetail.js';
import model_31 from '/app/src/pages/cm/black_list/models/blackLst.js';
import model_32 from '/app/src/pages/cm/emp_analysis/models/analysis.js';
import model_33 from '/app/src/pages/cm/emp_search/models/emp_search.js';
import model_34 from '/app/src/pages/cm/mm/ml/models/ml.js';
import model_35 from '/app/src/pages/cm/mm/models/memberManagement.js';
import model_36 from '/app/src/pages/coupon/batch_adjustment/models/batchAdjustment.js';
import model_37 from '/app/src/pages/coupon/coupon_add/models/couponAdd.js';
import model_38 from '/app/src/pages/coupon/coupon_data/models/cpData.js';
import model_39 from '/app/src/pages/coupon/coupon_list/models/cpList.js';
import model_40 from '/app/src/pages/coupon/coupon_re_gift_inquiry/models/couponRe.js';
import model_41 from '/app/src/pages/coupon/coupon_sale_report/models/couponSaleReport.js';
import model_42 from '/app/src/pages/coupon/coupon_use_list/models/cpUseList.js';
import model_43 from '/app/src/pages/coupon/employee_coupon/models/employee.js';
import model_44 from '/app/src/pages/coupon/employee_list/models/employeeList.js';
import model_45 from '/app/src/pages/coupon/setting/models/couponsSetting.js';
import model_46 from '/app/src/pages/data_tools/activity_data_tools/models/data_tools.js';
import model_47 from '/app/src/pages/data_tools/export_invoice/models/export_invoice.js';
import model_48 from '/app/src/pages/data/behavior_data/models/behaviorData.js';
import model_49 from '/app/src/pages/data/user_behavior/models/userBehavior.js';
import model_50 from '/app/src/pages/ec/cm/emp_analysis/models/analysis.js';
import model_51 from '/app/src/pages/ec/cm/mm/ml/models/ml.js';
import model_52 from '/app/src/pages/ec/cm/mm/models/memberManagement.js';
import model_53 from '/app/src/pages/ec/dashbord/models/index.js';
import model_54 from '/app/src/pages/ec/emp_search/models/emp_search.js';
import model_55 from '/app/src/pages/ec/order/order_detail/models/orderDetail.js';
import model_56 from '/app/src/pages/ec/order/order_list/models/orderList.js';
import model_57 from '/app/src/pages/ec/report/models/report.js';
import model_58 from '/app/src/pages/ec/ugc_dashbord/models/index.js';
import model_59 from '/app/src/pages/gift/card_management/models/cardManagement.js';
import model_60 from '/app/src/pages/gift/gift_card_shelf_data/models/giftCardShelfData.js';
import model_61 from '/app/src/pages/gift/gift_card_shelf_management/models/giftShelfManagement.js';
import model_62 from '/app/src/pages/gift/gift_data/models/giftData.js';
import model_63 from '/app/src/pages/goods/add_good/models/addGood.js';
import model_64 from '/app/src/pages/goods/goods_list/models/goodsList.js';
import model_65 from '/app/src/pages/integral/gift_exchange_record_form/models/giftExchangeRecord.js';
import model_66 from '/app/src/pages/integral/gift_exchange_record/models/giftExchangeRecord.js';
import model_67 from '/app/src/pages/integral/gift_management/models/giftManagement.js';
import model_68 from '/app/src/pages/integral/goods_shelf_management/models/goodsShelfManagement.js';
import model_69 from '/app/src/pages/integral/management_gift_form/models/managementGiftForm.js';
import model_70 from '/app/src/pages/integral/management_goods_shelf_form/models/managementGoodsShelfForm.js';
import model_71 from '/app/src/pages/login/models/login.js';
import model_72 from '/app/src/pages/loyalty/data_management/models/dataManagement.js';
import model_73 from '/app/src/pages/mail/mail_template_edit/models/mailTemplateEdit.js';
import model_74 from '/app/src/pages/mail/mail_template/models/mailTemplate.js';
import model_75 from '/app/src/pages/mail/send_record/models/sendRecord.js';
import model_76 from '/app/src/pages/marketing/account_activity_manage/models/index.js';
import model_77 from '/app/src/pages/marketing/activity_analyse/models/index.js';
import model_78 from '/app/src/pages/marketing/activity_fission/models/activityFission.js';
import model_79 from '/app/src/pages/marketing/activity_setting/models/activitySetting.js';
import model_80 from '/app/src/pages/marketing/activity_view/models/activityView.js';
import model_81 from '/app/src/pages/marketing/add_activity/models/addActivity.js';
import model_82 from '/app/src/pages/marketing/all_activity_analyse/models/index.js';
import model_83 from '/app/src/pages/marketing/all-account_activity_manage/models/index.js';
import model_84 from '/app/src/pages/marketing/analysis_of_activity/models/analysisOfActivity.js';
import model_85 from '/app/src/pages/marketing/appoint_activity_write_off/models/writeOff.js';
import model_86 from '/app/src/pages/marketing/appoint_activity/activity_analyze/models/activityAnalyze.js';
import model_87 from '/app/src/pages/marketing/appoint_activity/models/appointActivity.js';
import model_88 from '/app/src/pages/marketing/crowd_add/models/crowdAdd.js';
import model_89 from '/app/src/pages/marketing/crowd_list/models/operateList.js';
import model_90 from '/app/src/pages/marketing/luck_draw_view_report/models/report.js';
import model_91 from '/app/src/pages/marketing/luck_draw_view_setting/models/luckDrawViewSetting.js';
import model_92 from '/app/src/pages/marketing/luck_draw_view/models/luckyDraw.js';
import model_93 from '/app/src/pages/marketing/member_benefit_voucher_edit/models/voucherEdit.js';
import model_94 from '/app/src/pages/marketing/member_benefit_voucher/models/couponActivityList.js';
import model_95 from '/app/src/pages/marketing/registered_gift_form/models/registeredGiftForm.js';
import model_96 from '/app/src/pages/marketing/registered_gift/models/registeredGift.js';
import model_97 from '/app/src/pages/marketing/scene_marketing/models/sceneMarketing.js.js';
import model_98 from '/app/src/pages/marketing/vip_life_cycle/models/vipLifeCycle.js';
import model_99 from '/app/src/pages/message/mms/addMmsTemplate/models/addMmsTemplate.js';
import model_100 from '/app/src/pages/message/mms/mmsList/models/mmsList.js';
import model_101 from '/app/src/pages/message/mms/mmsReport/models/mmsReport.js';
import model_102 from '/app/src/pages/message/personalized_short_link_batch_sender/models/pslbs.js';
import model_103 from '/app/src/pages/message/sms_status/models/smsSendStatus.js';
import model_104 from '/app/src/pages/message/sms/addSmsTemplate/models/addSmsTemplate.js';
import model_105 from '/app/src/pages/message/sms/smsList/models/smsList.js';
import model_106 from '/app/src/pages/message/sms/smsReport/models/smsReport.js';
import model_107 from '/app/src/pages/message/wechat/addAutoReplyRule/models/addAutoReplyRule.js';
import model_108 from '/app/src/pages/message/wechat/addTemplate/models/addTemplate.js';
import model_109 from '/app/src/pages/message/wechat/autoReply/models/autoReply.js';
import model_110 from '/app/src/pages/message/wechat/material/auto_reply/models/wxAutoReply.js';
import model_111 from '/app/src/pages/message/wechat/qr_code_groups/models/qrCodeGroups.js';
import model_112 from '/app/src/pages/message/wechat/qr_code_manage_details/models/qrCodeManageDetails.js';
import model_113 from '/app/src/pages/message/wechat/qr_code_manage_view/models/qrCodeManageView.js';
import model_114 from '/app/src/pages/message/wechat/qr_code_manage/models/qrCodeManage.js';
import model_115 from '/app/src/pages/message/wechat/templateList/models/templateList.js';
import model_116 from '/app/src/pages/miniapps/addMaterial/models/addMaterial.js';
import model_117 from '/app/src/pages/miniapps/addTemplate/models/addTemplate.js';
import model_118 from '/app/src/pages/miniapps/materialList/models/materialList.js';
import model_119 from '/app/src/pages/miniapps/qr_code/models/miniQrCode.js';
import model_120 from '/app/src/pages/molding/gift_exchange_record_form/models/giftExchangeRecord.js';
import model_121 from '/app/src/pages/molding/gift_exchange_record/models/giftExchangeRecordMolding.js';
import model_122 from '/app/src/pages/molding/gift_management/models/giftManagement.js';
import model_123 from '/app/src/pages/molding/goods_shelf_management/models/goodsShelfManagement.js';
import model_124 from '/app/src/pages/molding/management_gift_form/models/managementGiftForm.js';
import model_125 from '/app/src/pages/molding/management_goods_shelf_form/models/managementGoodsShelfForm.js';
import model_126 from '/app/src/pages/order/order_detail/models/orderDetail.js';
import model_127 from '/app/src/pages/order/order_list/models/orderList.js';
import model_128 from '/app/src/pages/profile/crowd_manage/crowd_create_copy/models/crowdCreateCopy.js';
import model_129 from '/app/src/pages/profile/crowd_manage/crowd_detail/models/crowdDetail.js';
import model_130 from '/app/src/pages/profile/crowd_manage/crowd_import/models/crowdImport.js';
import model_131 from '/app/src/pages/profile/crowd_manage/models/crowdManage.js';
import model_132 from '/app/src/pages/profile/crowd_portrayal/models/crowdPortrayal.js';
import model_133 from '/app/src/pages/profile/label_manage/create_label/models/createLabel.js';
import model_134 from '/app/src/pages/profile/label_manage/models/labelManage.js';
import model_135 from '/app/src/pages/profile/label_manage/statistics_create_label/models/statisticsCreateLabel.js';
import model_136 from '/app/src/pages/report/activity_data_report_download/models/dataReportDownload.js';
import model_137 from '/app/src/pages/report/bhc/models/bhc.js';
import model_138 from '/app/src/pages/report/combatScreen/models/combatScreen.js';
import model_139 from '/app/src/pages/report/data_download/models/dataDownload.js';
import model_140 from '/app/src/pages/report/dtc/models/dtc.js';
import model_141 from '/app/src/pages/report/integral_flow_direction_report/models/integralFlow.js';
import model_142 from '/app/src/pages/report/member_data/models/memberData.js';
import model_143 from '/app/src/pages/report/member_order_analysis/models/memberOrderAnalysis.js';
import model_144 from '/app/src/pages/report/membership_report/models/membershipReport.js';
import model_145 from '/app/src/pages/report/mgm/models/mgm.js';
import model_146 from '/app/src/pages/report/nkc/models/nkc.js';
import model_147 from '/app/src/pages/report/pbi_monthly/models/pbiMonthly.js';
import model_148 from '/app/src/pages/report/pbi/models/pbi.js';
import model_149 from '/app/src/pages/report/perform_sales/models/perform_sales.js';
import model_150 from '/app/src/pages/report/store_information/models/storeInformation.js';
import model_151 from '/app/src/pages/report/storeMemberAnalysis/models/storeAnalysis.js';
import model_152 from '/app/src/pages/report/vip_data/models/vipData.js';
import model_153 from '/app/src/pages/report/weekly_sales_data/models/weeklySalesData.js';
import model_154 from '/app/src/pages/system/account_auth/models/accountAuth.js';
import model_155 from '/app/src/pages/task/my_task/models/myTask.js';

let app = null;
let store = null;

export function getApp() {
  return app;
}

export function getStore() {
  return store;
}

/**
 * Native-generator compatible loading plugin.
 * Stock dva-loading uses @babel/runtime regenerator wrappers; mixed with
 * SWC/native model effects, takeEvery never enters the effect → callback hangs.
 */
function createLoadingCompat() {
  const SHOW = '@@DVA_LOADING/SHOW';
  const HIDE = '@@DVA_LOADING/HIDE';
  const namespace = 'loading';

  const extraReducers = {
    [namespace](state, { type, payload }) {
      const prev = state || { global: false, models: {}, effects: {} };
      const ns = (payload && payload.namespace) || '';
      const actionType = (payload && payload.actionType) || '';
      switch (type) {
        case SHOW:
          return {
            ...prev,
            global: true,
            models: { ...prev.models, [ns]: true },
            effects: { ...prev.effects, [actionType]: true },
          };
        case HIDE: {
          const effects = { ...prev.effects, [actionType]: false };
          const models = {
            ...prev.models,
            [ns]: Object.keys(effects).some((t) => {
              const effectNs = t.split('/')[0];
              return effectNs === ns && effects[t];
            }),
          };
          const global = Object.keys(models).some((k) => models[k]);
          return { ...prev, global, models, effects };
        }
        default:
          return prev;
      }
    },
  };

  function onEffect(effect, { put }, model, actionType) {
    const ns = model.namespace;
    return function* loadingWrappedEffect(...args) {
      yield put({ type: SHOW, payload: { namespace: ns, actionType } });
      try {
        return yield effect(...args);
      } finally {
        yield put({ type: HIDE, payload: { namespace: ns, actionType } });
      }
    };
  }

  return { extraReducers, onEffect };
}

function ensureApp(opts = {}) {
  if (app) return app;
  const h = opts.history || history;
  const appDvaConfig = (appDva && appDva.config) || {};
  const userOnError = appDvaConfig.onError;
  app = create({
    ...appDvaConfig,
    onError(err, ...rest) {
      // Normalize nullish throws from `throw response` when response is missing
      const e =
        err == null
          ? Object.assign(new Error('[dva] effect error: null/undefined'), {
              _dontReject: false,
            })
          : err;
      if (typeof userOnError === 'function') {
        return userOnError(e, ...rest);
      }
      console.error('[dva]', e);
    },
  });
  // dva-core subscriptions receive history via app._history (set by full dva package)
  app._history = h;
  app.use(createLoadingCompat());
  app.model(model_0);
app.model(model_1);
app.model(model_2);
app.model(model_3);
app.model(model_4);
app.model(model_5);
app.model(model_6);
app.model(model_7);
app.model(model_8);
app.model(model_9);
app.model(model_10);
app.model(model_11);
app.model(model_12);
app.model(model_13);
app.model(model_14);
app.model(model_15);
app.model(model_16);
app.model(model_17);
app.model(model_18);
app.model(model_19);
app.model(model_20);
app.model(model_21);
app.model(model_22);
app.model(model_23);
app.model(model_24);
app.model(model_25);
app.model(model_26);
app.model(model_27);
app.model(model_28);
app.model(model_29);
app.model(model_30);
app.model(model_31);
app.model(model_32);
app.model(model_33);
app.model(model_34);
app.model(model_35);
app.model(model_36);
app.model(model_37);
app.model(model_38);
app.model(model_39);
app.model(model_40);
app.model(model_41);
app.model(model_42);
app.model(model_43);
app.model(model_44);
app.model(model_45);
app.model(model_46);
app.model(model_47);
app.model(model_48);
app.model(model_49);
app.model(model_50);
app.model(model_51);
app.model(model_52);
app.model(model_53);
app.model(model_54);
app.model(model_55);
app.model(model_56);
app.model(model_57);
app.model(model_58);
app.model(model_59);
app.model(model_60);
app.model(model_61);
app.model(model_62);
app.model(model_63);
app.model(model_64);
app.model(model_65);
app.model(model_66);
app.model(model_67);
app.model(model_68);
app.model(model_69);
app.model(model_70);
app.model(model_71);
app.model(model_72);
app.model(model_73);
app.model(model_74);
app.model(model_75);
app.model(model_76);
app.model(model_77);
app.model(model_78);
app.model(model_79);
app.model(model_80);
app.model(model_81);
app.model(model_82);
app.model(model_83);
app.model(model_84);
app.model(model_85);
app.model(model_86);
app.model(model_87);
app.model(model_88);
app.model(model_89);
app.model(model_90);
app.model(model_91);
app.model(model_92);
app.model(model_93);
app.model(model_94);
app.model(model_95);
app.model(model_96);
app.model(model_97);
app.model(model_98);
app.model(model_99);
app.model(model_100);
app.model(model_101);
app.model(model_102);
app.model(model_103);
app.model(model_104);
app.model(model_105);
app.model(model_106);
app.model(model_107);
app.model(model_108);
app.model(model_109);
app.model(model_110);
app.model(model_111);
app.model(model_112);
app.model(model_113);
app.model(model_114);
app.model(model_115);
app.model(model_116);
app.model(model_117);
app.model(model_118);
app.model(model_119);
app.model(model_120);
app.model(model_121);
app.model(model_122);
app.model(model_123);
app.model(model_124);
app.model(model_125);
app.model(model_126);
app.model(model_127);
app.model(model_128);
app.model(model_129);
app.model(model_130);
app.model(model_131);
app.model(model_132);
app.model(model_133);
app.model(model_134);
app.model(model_135);
app.model(model_136);
app.model(model_137);
app.model(model_138);
app.model(model_139);
app.model(model_140);
app.model(model_141);
app.model(model_142);
app.model(model_143);
app.model(model_144);
app.model(model_145);
app.model(model_146);
app.model(model_147);
app.model(model_148);
app.model(model_149);
app.model(model_150);
app.model(model_151);
app.model(model_152);
app.model(model_153);
app.model(model_154);
app.model(model_155);
  app.start();
  store = app._store;
  if (typeof window !== 'undefined') {
    window.g_app = app;
  }
  return app;
}

export function rootContainer(container, opts) {
  ensureApp(opts || {});
  return React.createElement(Provider, { store: app._store }, container);
}
